export default function Separator({
  orientation = "horizontal",
  className = "",
}: {
  orientation?: "horizontal" | "vertical";
  className?: string;
}) {
  return (
    <div
      className={
        orientation === "horizontal"
          ? `w-full h-px bg-gray-200 my-2 ${className}`
          : `h-full w-px bg-gray-200 mx-2 ${className}`
      }
    />
  );
}